import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IOrganizationStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;    
    lsOrgsTxt: string;
    lsManageOrgTxt: string;
    lsAddOrgTxt: string;
    lsUploadOrgTxt: string;
    lsActiveOrgTxt: string;
    lsInactiveOrgTxt: string;
    lsAllOrgTxt: string;
    lsNameTxt: string;
    lsContactFirstNameTxt: string;    
    lsContactLastNameTxt: string;
    lsContactPhoneTxt: string;
    lsContactEmailTxt: string;    
    lsEditTxt: string;
    lsDeactivateTxt: string;
    lsTotalTxt: string;
    lsActivateTxt: string;
    lsOrgFilterTxt: string;
    lsFilterTxt: string;
    lsTotalOrgTxt: string;
    lsAction: string;
    lsNoFilterTxt: string;
    lsClearFilterTxt: string;
    lsDwnldTxt: string;
    lsExportOrgTxt: string;
    lsExportOrgSuccessTxt: string;
    lsOkTxt: string;    
    lsPrintTxt: string;
    lsOrgListFilterTxt: string;
    lsNoActiveOrgErrTxt: string;
    lsAccNotAssignedTxt: string;
    lsPleaseNoteTxt: string;
    lsContactOrgTxt: string;
    lsEmailSentToOrgTxt: string;
    lsPleaseTryAgainTxt: string;
    lsContactTxt: string;
    lsDeactivatedTxt: string;
    lsActivatedTxt: string;
    lsOrgSuccessMsgTxt: string;
    lsCSVTxt: string;
    lsView: string;
}

let strings: IOrganizationStrings;
export default strings = new LocalizedStrings({
    en: {
        lsHomeTxt: 'Home',
        lsOrgsTxt: 'Organizations',
        lsManageOrgTxt: 'Manage Organization',
        lsAddOrgTxt: 'Add Organization',
        lsUploadOrgTxt: 'Upload New Organizations',
        lsActiveOrgTxt: 'Active Organizations',
        lsInactiveOrgTxt: 'Inactive Organizations',
        lsAllOrgTxt: 'All Organizations',
        lsNameTxt: 'Name',
        lsContactFirstNameTxt: 'Contact First Name',    
        lsContactLastNameTxt: 'Contact Last Name',   
        lsContactPhoneTxt: 'Contact Phone',
        lsContactEmailTxt: 'Contact Email',    
        lsEditTxt: 'Edit',
        lsDeactivateTxt: 'Deactivate',
        lsTotalTxt: 'Total',
        lsActivateTxt: 'Activate',
        lsOrgFilterTxt: 'Organization List Filter',
        lsFilterTxt: 'Filter',
        lsTotalOrgTxt: 'Total {0} Organizations',
        lsAction: 'Action',
        lsNoFilterTxt: 'No filters applied',
        lsClearFilterTxt: 'Clear Filters',
        lsDwnldTxt: 'Download',
        lsExportOrgTxt: 'Export Organization List',        
        lsExportOrgSuccessTxt: 'Organizations exported successfully without tests!',
        lsOkTxt: 'Ok',    
        lsPrintTxt: 'Print',
        lsOrgListFilterTxt: 'Organization List Filter',
        lsNoActiveOrgErrTxt: 'Error: No Active Organization(s)',
        lsAccNotAssignedTxt: 'Your account is not assigned to any active organizations',
        lsPleaseNoteTxt: 'Please note the following:',
        lsContactOrgTxt: 'Please contact your organization admin.',
        lsEmailSentToOrgTxt: 'Email sent to organization admin(s)',
        lsPleaseTryAgainTxt: 'Please try again later',
        lsContactTxt: 'Contact',
        lsDeactivatedTxt: 'deactivated',
        lsActivatedTxt: 'activated',
        lsOrgSuccessMsgTxt: 'Organization {0} successfully!',
        lsCSVTxt: 'CSV',
        lsView: 'View'
    },
    es: {
        lsHomeTxt: 'Casa',
        lsOrgsTxt: 'Organizaciones',
        lsManageOrgTxt: 'Administrar organización',
        lsAddOrgTxt: 'Agregar organización',
        lsUploadOrgTxt: 'Subir nuevas organizaciones',
        lsActiveOrgTxt: 'Organizaciones activas',
        lsInactiveOrgTxt: 'Organizaciones inactivas',
        lsAllOrgTxt: 'Todas las organizaciones',
        lsNameTxt: 'Nombre',
        lsContactFirstNameTxt: 'Contact First Name',    
        lsContactLastNameTxt: 'Contact Last Name',   
        lsContactPhoneTxt: 'teléfono de contacto',
        lsContactEmailTxt: 'Email de contacto',    
        lsEditTxt: 'Editar',
        lsDeactivateTxt: 'Desactivar',
        lsTotalTxt: 'Total',
        lsActivateTxt: 'Activar',
        lsOrgFilterTxt: 'Filtro de lista de organización',
        lsFilterTxt: 'Filtrar',
        lsTotalOrgTxt: 'Total {0} organizaciones',
        lsAction: 'Acción',
        lsNoFilterTxt: 'No se aplicaron filtros',
        lsClearFilterTxt: 'Borrar filtros',
        lsDwnldTxt: 'Descargar',
        lsExportOrgTxt: 'Lista de organizaciones de exportación',        
        lsExportOrgSuccessTxt: '¡Las organizaciones se exportan exitosamente sin pruebas!',
        lsOkTxt: 'De acuerdo',    
        lsPrintTxt: 'Impresión',
        lsOrgListFilterTxt: 'Organization List Filter',
        lsNoActiveOrgErrTxt: 'Error: No Active Organization(s)',
        lsAccNotAssignedTxt: 'Your account is not assigned to any active organizations',
        lsPleaseNoteTxt: 'Please note the following:',
        lsContactOrgTxt: 'Please contact your organization admin.',
        lsEmailSentToOrgTxt: 'Email sent to organization admin(s)',
        lsPleaseTryAgainTxt: 'Please try again later',
        lsContactTxt: 'Contact',
        lsDeactivatedTxt: 'deactivated',
        lsActivatedTxt: 'activated',
        lsOrgSuccessMsgTxt: 'Organization {0} successfully!',
        lsCSVTxt: 'CSV',
        lsView: 'View'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/organization/strings.organization.tsx